<template>
  <!-- -->
  <div class="image-data-setting mini-component">
    <div class="desc">
      个人信息为系统固定组件，不能修改内容，只能修改样式，终端用户和企业内部职员的显示内容可能不同
    </div>
    <form-items label-width="2.4rem" :columns="1">
      <form-item label="姓名字体" desc-message="通用字体大小为一般为24、32两个尺寸">
        <el-input-number style="width: 100%" v-model="settingData.fontSize" placeholder="请输入文本大小" @change="changeFontSize"/>
      </form-item>
      <form-item label="姓名颜色">
        <el-color-picker v-model="settingData.textColor" show-alpha @change="changeData"/>
      </form-item>
      <form-item label="电话字体" desc-message="通用字体大小为一般为24、32两个尺寸">
        <el-input-number style="width: 100%" v-model="settingData.phoneFontSize" placeholder="请输入文本大小" @change="changePhoneFontSize"/>
      </form-item>
      <form-item label="电话颜色">
        <el-color-picker v-model="settingData.phoneColor" show-alpha @change="changeData"/>
      </form-item>
      <form-item label="企业字体" desc-message="通用字体大小为一般为24、32两个尺寸">
        <el-input-number style="width: 100%" v-model="settingData.merchantFontSize" placeholder="请输入文本大小" @change="changeMerchantFontSize"/>
      </form-item>
      <form-item label="企业颜色">
        <el-color-picker v-model="settingData.merchantColor" show-alpha @change="changeData"/>
      </form-item>
      <form-item label="角色字体" desc-message="通用字体大小为一般为24、32两个尺寸">
        <el-input-number style="width: 100%" v-model="settingData.roleFontSize" placeholder="请输入文本大小" @change="changeRoleFontSize"/>
      </form-item>
      <form-item label="角色颜色">
        <el-color-picker v-model="settingData.roleColor" show-alpha @change="changeData"/>
      </form-item>
      <form-item label="按钮颜色">
        <el-color-picker v-model="settingData.settingBtnColor" show-alpha @change="changeData"/>
      </form-item>
    </form-items>
  </div>
</template>

<script>

import AloneData from "@/views/h5/common/sys/miniProgram/setting/component/AloneData.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";

export default {
  emits: ["change"],
  props: {
    data: {
      type: Object,
      default: () => {
        return {componentData: {}}
      }
    }
  },
  name: "",
  components: {
    AloneData, FormItems, FormItem
  },
  data() {
    return {
      settingData: {
        roleFontSize: "",
        roleTextSize: "",
        roleColor: "",
        merchantFontSize: "",
        merchantColor: "",
        merchantTextSize: "",
        phoneFontSize: "",
        phoneColor: "",
        phoneTextSize: "",
        settingBtnColor: "",
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.data.componentData || !this.data.componentData.itemImage) {
        this.settingData = {size: ""};
      } else {
        this.settingData = this.data.componentData;
      }
    },
    changeData() {
      this.$emit("change", {...this.data, componentData: this.settingData});
    },
    changeFontSize() {
      this.settingData.textSize = this.settingData.fontSize? this.settingData.fontSize / 37 + "rem" : "";
      this.changeData();
    },
    changeRoleFontSize() {
      this.settingData.roleTextSize = this.settingData.roleFontSize? this.settingData.roleFontSize / 37 + "rem" : "";
      this.changeData();
    },
    changeMerchantFontSize() {
      this.settingData.merchantTextSize = this.settingData.merchantFontSize? this.settingData.merchantFontSize / 37 + "rem" : "";
      this.changeData()
    },
    changePhoneFontSize() {
      this.settingData.phoneTextSize = this.settingData.phoneFontSize? this.settingData.phoneFontSize / 37 + "rem" : "";
      this.changeData();
    },
  }
};
</script>

<style lang="scss" scoped>
.image-data-setting{

}
</style>